import axios from "@/plugins/axios";

import banners from "./banners";
import boards from "./boards";
import center from "./center";
import chat from "./chat";
import expo from "./expo";
import forms from "./forms";
import lectures from "./lectures";
import levels from "./levels";
import messages from "./messages";
import popups from "./popups";
import recruitments from "./recruitments";
import setting from "./setting";
import statistics from "./statistics";
import terms from "./terms";
import users from "./users";

export default {
    banners,
    boards,
    center,
    chat,
    expo,
    forms,
    lectures,
    levels,
    messages,
    popups,
    recruitments,
    setting,
    statistics,
    terms,
    users,
    email: {
        post({ to, subject, html }) {
            return axios.post("/api/console/email", { to, subject, html }).then((result) => result.data);
        },
    },
    message: {
        post({ to, subject, message }) {
            return axios.post("/api/console/message", { to, subject, message }).then((result) => result.data);
        },
    },
};
